import { ChatMock } from "./previews/ChatMock";
import { InterfaceMock } from "./previews/InterfaceMock";
import { TableMock } from "./previews/TableMock";
import { ZapMock } from "./previews/ZapMock";

type PreviewProps = {
  type: "table" | "zap" | "interface" | "chatbot";
};

export const AssetPreview = ({ type }: PreviewProps) => {
  switch (type) {
    case "table":
      return <TableMock />;
    case "zap":
      return <ZapMock />;
    case "interface":
      return <InterfaceMock />;
    case "chatbot":
      return <ChatMock />;
    default:
      return null;
  }
};
